export default {
    data() {
        return {
            scrolling: {
                useNative: false,
                // nur bei Hover und beim Scrollen (Kundenwunsch 13.10.2026: dauerhaft sichtbare Balken wirkten wie Linien)
                showScrollbar: 'onHover',
                scrollByThumb: true,
                scrollByContent: true
            },
            pageSizes: [5, 10, 30, 50, 100],
            defaultPageSize: 30,
            
        }
    },
    computed: {
        // Touch-Dichte für DevExtreme-Optionen (hoverStateEnabled, allowColumnResizing/-Reordering, headerFilter)
        gridTouch() {
            return !!(this.$dichte && this.$dichte.touch);
        }
    }
};
